import _ from 'lodash';
import template from './moving.html';
import './moving.scss';

class MovingController {
    /*@ngInject*/ 
    constructor(constants) {
        this.constants = constants;
    }

    $onInit() {
        this.isEnabled = _.get(this.constants, 'beta.moving', true);
    }
}

export default {
    template: template,
    bindings: {},
    controller: MovingController
};